const reportersModule = {
  firestorePath: "reporters",
  firestoreRefType: "collection", // or 'doc'
  moduleName: "reporters",
  statePropName: "reporters",
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {},
  mutations: {},
  actions: {}
};
export default reportersModule;
